import { render, staticRenderFns } from "./evidenceList.vue?vue&type=template&id=7bfb57b1&scoped=true&"
import script from "./evidenceList.vue?vue&type=script&lang=js&"
export * from "./evidenceList.vue?vue&type=script&lang=js&"
import style0 from "./evidenceList.vue?vue&type=style&index=0&id=7bfb57b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb57b1",
  null
  
)

export default component.exports